import { useQuery } from 'react-query';
import { GetResearchAnalysts } from 'services/apiServices';
import { Errors, TGetResearchAnalystsResult } from 'types/ApiServicesTypes';

export default function useGetResearchAnalysts() {
  const objQuery = useQuery<TGetResearchAnalystsResult, Errors>(
    ['GetResearchAnalysts'],
    () => GetResearchAnalysts(),
  );
  return objQuery;
}
